import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-info",
  "use": "svg-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"currentColor\" id=\"svg-info\"><path d=\"M7.42,7.75v3.69H6.38v1.58h4.24v-1.58H9.6v-5.27H6.38v1.58Zm.28-2.7A1.19,1.19,0,0,0,9.73,4.21a1.16,1.16,0,0,0-.35-.85,1.19,1.19,0,0,0-1.69,0,1.16,1.16,0,0,0-.35.85A1.14,1.14,0,0,0,7.69,5.05Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol